<div class="auto-fill-section">
  @if (orPosition === "top") {
    <div class="auto-fill-or">
      <span>{{ "CASE_FORM.FORMS.INVOICE.OR_ENTER_DATA" | translate }}</span>
    </div>
  }

  <app-invoice-ocr-uploader></app-invoice-ocr-uploader>

  @if (orPosition === "bottom") {
    <div class="auto-fill-or">
      <span>{{ "CASE_FORM.FORMS.INVOICE.OR_ENTER_DATA" | translate }}</span>
    </div>
  }
</div>
